import { Dayjs } from "dayjs";
import React, { MutableRefObject } from "react";
import { useFormContext } from "react-hook-form";
import { OnChangeValue, Props as ReactSelectProps } from "react-select";
import { SelectOption } from "../../../../types/select";
import { ReactSelectField } from "../../../atoms/FormElement";
import { calculateLeaseEndDate } from "./utils";

export type LeaseEndDateRefType = { actual: Dayjs | null; withRentFreePeriod: Dayjs | null };

type NumberOfYearsSelectProps = Pick<ReactSelectProps, "options" | "isDisabled"> & {
  leaseEndDateRef?: MutableRefObject<LeaseEndDateRefType>;
  label?: string;
};

export const NumberOfYearsSelect = (props: NumberOfYearsSelectProps) => {
  const { options, isDisabled, leaseEndDateRef, label } = props;

  const { control, setValue, getValues } = useFormContext();

  const handleChange = (event: OnChangeValue<SelectOption, false>) => {
    const leaseStartDate = getValues("leaseStartDate");

    if (!leaseStartDate) return;

    if (event.value === "custom") {
      setValue("leaseEndDate", leaseStartDate);
      leaseEndDateRef.current.actual = leaseStartDate;
    } else {
      const newLeaseEndDate = calculateLeaseEndDate(leaseStartDate, parseInt(event.value));
      setValue("leaseEndDate", newLeaseEndDate, { shouldDirty: true, shouldValidate: true });
      leaseEndDateRef.current.actual = newLeaseEndDate;
    }

    setValue("rentFreePeriod", null);
    leaseEndDateRef.current.withRentFreePeriod = null;
  };

  return (
    <ReactSelectField
      control={control}
      setValue={setValue}
      label={label || "Number of years"}
      fieldname="numberOfYears"
      initValue={options[0]}
      selectOption={options}
      isDisabled={isDisabled}
      iProps={{ placeholder: "Select number of years" }}
      onChange={handleChange}
    />
  );
};
